export const COMPANY = {
  name: "Impresa Edile Lici",
  legal: "Impresa Edile Lici S.a.s. di Lici Armand e C.",
  phone: "+39 351 589 7637",
  phoneHref: "tel:+393515897637",
  email: "ftvlici@gmail.com",
  emailHref: "mailto:ftvlici@gmail.com",
  address: "Via F.lli Caboto 5, Seveso (MB)",
  addressMapUrl: "https://www.google.com/maps/search/?api=1&query=Via+F.lli+Caboto+5+Seveso+MB",
  logo: "https://customer-assets.emergentagent.com/job_9e120fc8-9c57-4101-9b7f-62eed088fe86/artifacts/izvpcvo7_89B99FF3-49CF-4747-B9D4-8C9791D8CA04.jpeg",
};

export const IMAGES = {
  // ============ REAL CUSTOMER PHOTOS (lavori realizzati) ============
  // Worker safety / installation on tile roofs
  realRooftopWorkers1:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/dmm2tjgn_WhatsApp%20Image%202026-06-16%20at%208.00.04%E2%80%AFPM.jpeg",
  realRooftopWorkers2:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/saaea3i6_WhatsApp%20Image%202026-06-16%20at%208.00.03%E2%80%AFPM.jpeg",
  realRooftopWorkers3:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/jasd3xpk_WhatsApp%20Image%202026-06-16%20at%208.00.02%E2%80%AFPM.jpeg",
  // Aerial drone shots of completed installations
  realAerial1:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/3oi2q0w1_WhatsApp%20Image%202026-06-16%20at%207.58.24%E2%80%AFPM.jpeg",
  realAerial2:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/8edk6wch_WhatsApp%20Image%202026-06-16%20at%207.58.24%E2%80%AFPM%20%281%29.jpeg",
  // Metal-roof carport / garage installations
  realCarportAerial1:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/i5fr76r5_WhatsApp%20Image%202026-06-17%20at%2011.23.14%E2%80%AFAM.jpeg",
  realCarportAerial2:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/hiusphqf_WhatsApp%20Image%202026-06-17%20at%2011.23.14%E2%80%AFAM%20%281%29.jpeg",
  realCarportSide:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/d3xhplij_WhatsApp%20Image%202026-06-17%20at%2011.23.15%E2%80%AFAM.jpeg",
  // Premium dark panels on terracotta tile roof villas
  realVilla1:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/yd2c1oz6_WhatsApp%20Image%202026-06-17%20at%2011.30.05%E2%80%AFAM.jpeg",
  realVilla2:
    "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/l9sg77kj_WhatsApp%20Image%202026-06-17%20at%2011.37.27%E2%80%AFAM.jpeg",

  // ============ Aliases used across the site (real where possible) ============
  heroLuxury: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/l9sg77kj_WhatsApp%20Image%202026-06-17%20at%2011.37.27%E2%80%AFAM.jpeg",
  residential: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/yd2c1oz6_WhatsApp%20Image%202026-06-17%20at%2011.30.05%E2%80%AFAM.jpeg",
  villaWithPv: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/dmm2tjgn_WhatsApp%20Image%202026-06-16%20at%208.00.04%E2%80%AFPM.jpeg",
  industrial: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/i5fr76r5_WhatsApp%20Image%202026-06-17%20at%2011.23.14%E2%80%AFAM.jpeg",
  industrialPlant: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/d3xhplij_WhatsApp%20Image%202026-06-17%20at%2011.23.15%E2%80%AFAM.jpeg",
  industrialField:
    "https://images.pexels.com/photos/15751131/pexels-photo-15751131.jpeg?auto=compress&cs=tinysrgb&w=1600",
  groundPv: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/3oi2q0w1_WhatsApp%20Image%202026-06-16%20at%207.58.24%E2%80%AFPM.jpeg",
  groundField1:
    "https://images.pexels.com/photos/13989282/pexels-photo-13989282.jpeg?auto=compress&cs=tinysrgb&w=1600",
  groundField2:
    "https://images.pexels.com/photos/15751134/pexels-photo-15751134.jpeg?auto=compress&cs=tinysrgb&w=1600",
  groundField3:
    "https://images.pexels.com/photos/33537433/pexels-photo-33537433.jpeg?auto=compress&cs=tinysrgb&w=1600",
  groundItaly:
    "https://images.pexels.com/photos/16586150/pexels-photo-16586150.jpeg?auto=compress&cs=tinysrgb&w=1600",
  groundAerial:
    "https://images.pexels.com/photos/2800845/pexels-photo-2800845.jpeg?auto=compress&cs=tinysrgb&w=1600",
  groundTrackers:
    "https://images.pexels.com/photos/4320449/pexels-photo-4320449.jpeg?auto=compress&cs=tinysrgb&w=1600",

  // SAFETY (real worker shots replace stock)
  maintenance: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/saaea3i6_WhatsApp%20Image%202026-06-16%20at%208.00.03%E2%80%AFPM.jpeg",
  workerSafety: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/jasd3xpk_WhatsApp%20Image%202026-06-16%20at%208.00.02%E2%80%AFPM.jpeg",
  workerRoof1: "https://customer-assets.emergentagent.com/job_lici-fotovoltaico/artifacts/dmm2tjgn_WhatsApp%20Image%202026-06-16%20at%208.00.04%E2%80%AFPM.jpeg",
  workerCarryPanel:
    "https://images.pexels.com/photos/8853504/pexels-photo-8853504.jpeg?auto=compress&cs=tinysrgb&w=1600",
  workerPPE:
    "https://images.pexels.com/photos/8853471/pexels-photo-8853471.jpeg?auto=compress&cs=tinysrgb&w=1600",
  workerSafetyGear:
    "https://images.pexels.com/photos/8853470/pexels-photo-8853470.jpeg?auto=compress&cs=tinysrgb&w=1600",
  inspectorHardhat:
    "https://images.pexels.com/photos/4254163/pexels-photo-4254163.jpeg?auto=compress&cs=tinysrgb&w=1600",
  electricianDrill:
    "https://images.pexels.com/photos/4254164/pexels-photo-4254164.jpeg?auto=compress&cs=tinysrgb&w=1600",
  orangeHardhat:
    "https://images.pexels.com/photos/8853540/pexels-photo-8853540.jpeg?auto=compress&cs=tinysrgb&w=1600",
  twoWorkers:
    "https://images.pexels.com/photos/8853539/pexels-photo-8853539.jpeg?auto=compress&cs=tinysrgb&w=1600",
  workersInstall:
    "https://images.pexels.com/photos/6961122/pexels-photo-6961122.jpeg?auto=compress&cs=tinysrgb&w=1600",
  rooftopInstall:
    "https://images.pexels.com/photos/11645008/pexels-photo-11645008.jpeg?auto=compress&cs=tinysrgb&w=1600",
  rooftopWorker:
    "https://images.pexels.com/photos/9875422/pexels-photo-9875422.jpeg?auto=compress&cs=tinysrgb&w=1600",

  // CLEANING
  panelsCleaning:
    "https://images.pexels.com/photos/14614266/pexels-photo-14614266.jpeg?auto=compress&cs=tinysrgb&w=1600",
  cleaningBrush:
    "https://images.pexels.com/photos/33379364/pexels-photo-33379364.jpeg?auto=compress&cs=tinysrgb&w=1600",
  cleaningTeam:
    "https://images.pexels.com/photos/11645003/pexels-photo-11645003.jpeg?auto=compress&cs=tinysrgb&w=1600",
  cleaningSingle:
    "https://images.pexels.com/photos/14673364/pexels-photo-14673364.jpeg?auto=compress&cs=tinysrgb&w=1600",

  // RENOVATION
  renovation:
    "https://images.pexels.com/photos/5511085/pexels-photo-5511085.jpeg?auto=compress&cs=tinysrgb&w=1600",
  renovationScaffold:
    "https://images.pexels.com/photos/15767414/pexels-photo-15767414.jpeg?auto=compress&cs=tinysrgb&w=1600",
  renovationModern:
    "https://images.pexels.com/photos/27134625/pexels-photo-27134625.jpeg?auto=compress&cs=tinysrgb&w=1600",
  renovationHouse:
    "https://images.pexels.com/photos/28885512/pexels-photo-28885512.jpeg?auto=compress&cs=tinysrgb&w=1600",
  renovationFacade:
    "https://images.pexels.com/photos/31569140/pexels-photo-31569140.jpeg?auto=compress&cs=tinysrgb&w=1600",
  renovationInterior:
    "https://images.unsplash.com/photo-1517581177682-a085bb7ffb15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxob3VzZSUyMHJlbm92YXRpb258ZW58MHx8fHwxNzc5NDYzOTMyfDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "installazione",
    title: "Installazione Impianti",
    subtitle: "Civili e Industriali",
    icon: "Sun",
    image: IMAGES.residential,
    description:
      "Realizziamo impianti fotovoltaici \"chiavi in mano\", dimensionati sulle reali necessità del cliente. Dal piccolo impianto residenziale sul tetto di casa ai grandi parchi a terra per l'azienda, garantiamo materiali di prima scelta e installazioni a regola d'arte.",
    highlights: [
      "Sopralluogo e progettazione personalizzata",
      "Pannelli e inverter di prima scelta",
      "Pratiche burocratiche incluse",
      "Connessione e attivazione GSE",
    ],
  },
  {
    id: "manutenzione",
    title: "Assistenza e Manutenzione",
    subtitle: "Programmata e su Chiamata",
    icon: "Wrench",
    image: IMAGES.maintenance,
    description:
      "Il tuo impianto rende meno del previsto? Offriamo servizi di monitoraggio, diagnostica e riparazione guasti su impianti di qualsiasi taglia. La manutenzione regolare previene i malfunzionamenti e allunga la vita dei tuoi pannelli.",
    highlights: [
      "Monitoraggio produzione e diagnostica",
      "Riparazione guasti rapida",
      "Sostituzione inverter e ottimizzatori",
      "Contratti di manutenzione annuali",
    ],
  },
  {
    id: "lavaggio",
    title: "Lavaggio e Manutenzione Pannelli",
    subtitle: "Servizio Professionale Fotovoltaico",
    icon: "Droplets",
    image: IMAGES.panelsCleaning,
    description:
      "Offriamo un servizio professionale di lavaggio e manutenzione di pannelli fotovoltaici, garantendo il massimo rendimento energetico al tuo impianto. Polvere, smog, escrementi di volatili e intemperie riducono l'efficienza energetica dei moduli fino al 25%: interveniamo con attrezzature idriche adeguate e metodologie di pulizia antigraffio per preservare l'investimento nel tempo.",
    highlights: [
      "Piccoli e grandi impianti, dal residenziale ai parchi industriali",
      "Coperture civili, industriali, tetti piani o inclinati",
      "Campi solari a terra e impianti a inseguimento",
      "Acqua demineralizzata e spazzole antigraffio",
      "Operatori certificati per lavori in quota",
      "Report fotografico pre/post lavaggio",
    ],
  },
];

export const VALUES = [
  {
    title: "Sicurezza Certificata",
    description:
      "Lavoriamo nel pieno rispetto delle normative vigenti. Il nostro personale è formato per operare in quota e su grandi superfici in totale sicurezza.",
    icon: "ShieldCheck",
  },
  {
    title: "Attrezzature Specializzate",
    description:
      "Utilizziamo macchinari professionali specifici per il lavaggio, che non danneggiano le superfici e garantiscono un risultato impeccabile.",
    icon: "Cog",
  },
  {
    title: "Servizio a 360°",
    description:
      "Dal piccolo impianto domestico al grande impianto industriale, seguiamo ogni fase: dalla progettazione alla burocrazia, fino all'assistenza post-installazione.",
    icon: "Workflow",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/edilizia", label: "Edilizia" },
  { to: "/gallery", label: "Gallery" },
  { to: "/faq", label: "FAQ" },
  { to: "/contatti", label: "Contatti" },
];
